import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { adminActions } from "../store/adminSlice";
import Alert from "../components/Alert";
import validator from "../functions/Validator";
import URL from "../functions/URLString";

function ResetPassword() {
  const dispatch = useDispatch();
  const stateAlert = useSelector((state) => state.admin.alert);
  const location = useLocation();
  const token = location.pathname.split("/reset-password/")[1];

  const [passwordData, setPasswordData] = useState({
    newPassword: "",
    confirmPassword: "",
  });
  const [alert, setAlert] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (!token) {
      dispatch(
        adminActions.addAlert({
          type: "unsuccess",
          title: "Error",
          message: "Invalid reset token",
        })
      );
      setAlert(true);
      setTimeout(() => {
        navigate("/signin");
      }, 2000);
    }
  }, [token, dispatch, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (passwordData.newPassword && passwordData.confirmPassword) {
      if (passwordData.newPassword === passwordData.confirmPassword) {
        try {
          const response = await fetch(URL + "customer/reset-password", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              token,
              newPassword: passwordData.newPassword,
            }),
          });

          const data = await response.json();

          if (response.ok) {
            dispatch(
              adminActions.addAlert({
                type: "success",
                title: "Success",
                message: "Password has been reset successfully",
              })
            );
            setAlert(true);
            setTimeout(() => {
              navigate("/signin");
            }, 2000);
          } else {
            dispatch(
              adminActions.addAlert({
                type: "unsuccess",
                title: "Error",
                message: data.message || "Failed to reset password",
              })
            );
            setAlert(true);
          }
        } catch (error) {
          dispatch(
            adminActions.addAlert({
              type: "unsuccess",
              title: "Error",
              message: "An error occurred. Please try again later.",
            })
          );
          setAlert(true);
        }
      } else {
        dispatch(
          adminActions.addAlert({
            type: "unsuccess",
            title: "Error",
            message: "Passwords do not match",
          })
        );
        setAlert(true);
      }
    } else {
      dispatch(
        adminActions.addAlert({
          type: "unsuccess",
          title: "Error",
          message: "Please fill in all fields",
        })
      );
      setAlert(true);
    }
  };

  return (
    <div className="w-full min-h-screen bg-white flex flex-col items-center justify-center py-8 px-4">
      <div className="flex flex-col items-center mb-8">
        <img src="/logo-sdl.png" alt="SDL Logo" className="w-24 h-auto mb-4" />
        <h2 className="text-xl font-bold text-gray-800 text-center">
          Reset Your Password
        </h2>
      </div>

      <div className="w-full max-w-md bg-white rounded-lg shadow-xl p-6 md:p-8">
        <form
          autoComplete="off"
          noValidate
          onSubmit={handleSubmit}
          className="space-y-6"
        >
          {alert && (
            <Alert
              type={stateAlert[0]}
              title={stateAlert[1]}
              message={stateAlert[2]}
            />
          )}

          <div className="space-y-4">
            <div>
              <label
                htmlFor="newPassword"
                className="block text-sm font-medium text-gray-700 mb-1"
              >
                New Password
              </label>
              <input
                id="newPassword"
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#66c18a] focus:border-[#66c18a] mobile-friendly-input"
                type="password"
                autoComplete="new-password"
                onChange={(e) =>
                  setPasswordData({
                    ...passwordData,
                    newPassword: validator(e.target.value),
                  })
                }
                value={passwordData.newPassword}
                placeholder="Enter new password"
              />
            </div>

            <div>
              <label
                htmlFor="confirmPassword"
                className="block text-sm font-medium text-gray-700 mb-1"
              >
                Confirm New Password
              </label>
              <input
                id="confirmPassword"
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#66c18a] focus:border-[#66c18a] mobile-friendly-input"
                type="password"
                autoComplete="new-password"
                onChange={(e) =>
                  setPasswordData({
                    ...passwordData,
                    confirmPassword: validator(e.target.value),
                  })
                }
                value={passwordData.confirmPassword}
                placeholder="Confirm new password"
              />
            </div>
          </div>

          <div className="space-y-3">
            <button
              type="submit"
              className="w-full py-2 px-4 bg-[#66c18a] hover:bg-[#59b37d] text-white font-medium rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#66c18a] transition-colors duration-200 mobile-friendly-button"
            >
              Reset Password
            </button>

            <button
              type="button"
              className="w-full py-2 px-4 border border-[#66c18a] text-[#66c18a] hover:bg-gray-50 font-medium rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#66c18a] transition-colors duration-200 mobile-friendly-button"
              onClick={() => navigate("/signin")}
            >
              Back to Sign In
            </button>
          </div>

          <div className="text-center">
            <span
              className="text-sm text-[#66c18a] hover:underline cursor-pointer"
              onClick={() => navigate("/signin")}
            >
              Remember your password?
            </span>
          </div>
        </form>
      </div>
    </div>
  );
}

export default ResetPassword;
